var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { isPointInside, rayPolygonIntersection } from "@project-rouge/rg-three";
import { Vector3 } from "three";
import { ThreadData } from "./index197.js";
class ThreadCollider {
  constructor(props) {
    __publicField(this, "data");
    this.data = new ThreadData(props);
  }
  /** Raycast from thread position to boundary and holes
   * @returns the maximum length that the thread can grow
   */
  getGrowLimit(forward) {
    const dir = forward ? this.data.dir : this.data.nDir;
    const sideHits = [];
    const sidePoints = forward ? this.data.sidePoints : this.data.sidePoints.slice().reverse();
    for (const start of sidePoints) {
      const hit = getClosestInsideHit(
        start,
        dir,
        this.data.boundary
      );
      if (!hit)
        return 0;
      sideHits.push(hit);
    }
    const hits = this.getPointsFromSideHits(sideHits);
    for (const start of sidePoints) {
      for (const hole of this.data.holes) {
        const holeHit = getClosestInsideHit(
          start,
          dir,
          hole
        );
        if (holeHit)
          hits.push(holeHit.point);
      }
    }
    let dist = Infinity;
    for (let i = 0; i < hits.length; i++) {
      const newDist = hits[i].sub(sidePoints[0]).dot(dir);
      if (dist < newDist)
        continue;
      dist = newDist;
    }
    dist = this.trimLength(dist);
    return dist;
  }
  /** trims the max growth size according to max wing length specified */
  trimLength(raycastedLength) {
    var _a;
    const currentSize = this.data.updateSize();
    let maxGrowthSize = raycastedLength;
    if (currentSize + maxGrowthSize >= this.data.maxWingLength)
      maxGrowthSize = this.data.maxWingLength - currentSize;
    if (!this.data.isMain) {
      const mainThreadDepth = ((_a = this.data.getMainBranch()) == null ? void 0 : _a.depth) || 0;
      if (maxGrowthSize + mainThreadDepth >= this.data.maxWingLength)
        maxGrowthSize = this.data.maxWingLength - mainThreadDepth;
    }
    return maxGrowthSize;
  }
  isInsideHole() {
    for (const start of this.data.sidePoints) {
      if (this.data.holes.some((poly) => isPointInside(start, poly)))
        return true;
    }
    return false;
  }
  isInsideBoundary() {
    for (const start of this.data.sidePoints) {
      if (!isPointInside(start, this.data.boundary))
        return false;
    }
    return true;
  }
  /** collect all potential closest points between two side hits */
  getPointsFromSideHits(sideHits) {
    const points = sideHits.map((hit) => hit.point);
    const lastEdge = sideHits[0].index <= sideHits[1].index ? sideHits[1].index : sideHits[1].index + this.data.boundary.length - 1;
    for (let i = sideHits[0].index; i < lastEdge; i++) {
      const boundaryPoint = this.data.boundary[(i + 1) % this.data.boundary.length];
      points.push(boundaryPoint.clone());
    }
    return points;
  }
}
const aStart = new Vector3();
function getClosestInsideHit(start, dir, polygon) {
  let hits = rayPolygonIntersection({ polygon, ray: { start, dir }, calculateEnters: false });
  hits = hits.filter((a) => {
    aStart.copy(a.point).sub(start);
    return (Math.sign(aStart.dot(dir)) || 1) === 1;
  });
  hits.sort((a, b) => {
    return a.point.distanceToSquared(start) - b.point.distanceToSquared(start);
  });
  return hits.at(0);
}
export {
  ThreadCollider
};
//# sourceMappingURL=index252.js.map
